/**
 * Entity mirroring `case_complaint_references` table.
 */
export class WozCaseComplaintReferenceEntity {
  id: string | null;
  type: string;
  startPosition: number;
  endPosition: number;
  citation: string;
  value: string;
  metadata: Record<string, unknown> | null;

  constructor(data: Partial<WozCaseComplaintReferenceEntity> = {}) {
    this.id = data.id ?? null;
    this.type = data.type ?? 'address';
    this.startPosition = data.startPosition ?? 0;
    this.endPosition = data.endPosition ?? 0;
    this.citation = data.citation ?? '';
    this.value = data.value ?? '';
    this.metadata = data.metadata ?? null;
  }

  toJSON() {
    return {
      id: this.id,
      type: this.type,
      startPosition: this.startPosition,
      endPosition: this.endPosition,
      citation: this.citation,
      value: this.value,
      metadata: this.metadata,
    };
  }
}
